import { createAction } from 'redux-actions';
import { SET_CURRENT_INBOX } from '../constants/unifiedInboxActionTypes';
const setCurrentInbox = createAction(SET_CURRENT_INBOX);
export { setCurrentInbox as default, setCurrentInbox };